module.exports = __webpack_public_path__ + "static/youth-26da98ce6fa17bf1e7e45180f350f6c5.png";